/**
 * useBrands — รายการแบรนด์/ธุรกิจจาก DB (ไม่ hardcode)
 * ใช้แทน const BRANDS = ['scrub','bow'] เดิม → เพิ่มธุรกิจใหม่ในเวปแล้วโผล่ทุกหน้า
 *
 * - useBrands(): hook คืน { brands, keys, loading } (เฉพาะที่ active) + อัปเดต cache ป้ายชื่อ
 * - brandLabel(key) / brandEmoji(key): อ่าน cache แบบ sync ใช้ใน label expression ได้
 */
import { useQuery } from '@tanstack/react-query';
import { BrandsApi, type BrandItem } from './admin-api';

// cache ป้ายชื่อให้เรียกแบบ sync ได้ (เติมจาก hook)
const labelCache: Record<string, string> = { scrub: 'Cher Scrub', bow: 'Cherlyn' };
const emojiCache: Record<string, string> = { scrub: '🩺', bow: '🎀' };

export function brandLabel(key: string): string {
  return labelCache[key] ?? key;
}
export function brandEmoji(key: string): string {
  return emojiCache[key] ?? '🏢';
}

export function useBrands(opts?: { includeInactive?: boolean }) {
  const q = useQuery({
    queryKey: ['brands'],
    queryFn: BrandsApi.list,
    staleTime: 60_000,
  });
  const all: BrandItem[] = q.data ?? [];
  for (const b of all) {
    labelCache[b.brand_key] = b.name;
    emojiCache[b.brand_key] = b.emoji ?? '🏢';
  }
  const brands = opts?.includeInactive ? all : all.filter((b) => b.active);
  return { brands, keys: brands.map((b) => b.brand_key), loading: q.isLoading, refetch: q.refetch };
}
